// Quem theme JS — drives the ticker, category slider and gift-finder wizard.
// All content comes from the section markup / Customizer, so this file
// never needs editing when a merchant changes copy.

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- In-page anchor smooth scroll ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.length > 1) {
        var el = document.querySelector(id);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  /* ---------- Trusted Clients ticker (duplicate marks for seamless loop) ---------- */
  document.querySelectorAll('.ticker-track').forEach(function (track) {
    if (track.dataset.looped === '1') return;
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.looped = '1';
  });

  /* ---------- Category slider: infinite loop on tablet/mobile ---------- */
  document.querySelectorAll('.occ-rail').forEach(function (rail) {
    var scroller = rail.querySelector('.occasions');
    var prev = rail.querySelector('.occ-arrow--prev');
    var next = rail.querySelector('.occ-arrow--next');
    if (!scroller || !prev || !next) return;

    var originals = Array.prototype.slice.call(scroller.children);
    var cloned = false;

    function isCarousel() { return getComputedStyle(scroller).display === 'flex'; }
    function step() {
      var card = scroller.querySelector('.occ-card');
      if (!card) return 240;
      var styles = getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '14') || 14;
      return card.getBoundingClientRect().width + gap;
    }
    function originalWidth() { return step() * originals.length; }
    function ensureClones() {
      var want = isCarousel();
      if (want && !cloned) {
        originals.forEach(function (el) {
          var c = el.cloneNode(true);
          c.classList.add('occ-clone');
          c.setAttribute('aria-hidden', 'true');
          scroller.appendChild(c);
        });
        cloned = true;
      } else if (!want && cloned) {
        scroller.querySelectorAll('.occ-clone').forEach(function (c) { c.remove(); });
        cloned = false;
        scroller.scrollLeft = 0;
      }
    }
    function onScroll() {
      if (!isCarousel() || !cloned) return;
      var w = originalWidth();
      if (w > 0 && scroller.scrollLeft >= w) scroller.scrollLeft -= w;
    }
    function go(dir) {
      if (!isCarousel()) return;
      if (dir < 0 && scroller.scrollLeft < 1) scroller.scrollLeft = originalWidth();
      scroller.scrollBy({ left: step() * dir, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', ensureClones);
    ensureClones();
  });

  /* ---------- Gift-Finder wizard (data-driven from section markup) ---------- */
  document.querySelectorAll('.wizard-card').forEach(function (wizCard) {
    var groups   = Array.prototype.slice.call(wizCard.querySelectorAll('.wiz-options'));
    if (!groups.length) return;
    var backBtn  = wizCard.querySelector('.wiz-back');
    var nextBtn  = wizCard.querySelector('.wiz-next');
    var sendBtn  = wizCard.querySelector('.wiz-send');
    var stepLab  = wizCard.querySelector('.wiz-step-label');
    var barFill  = wizCard.querySelector('.wiz-bar-fill');
    var sumList  = wizCard.querySelector('.wiz-summary-list');
    var nameIn   = wizCard.querySelector('.wiz-name');
    var waIn     = wizCard.querySelector('.wiz-whatsapp');
    var compIn   = wizCard.querySelector('.wiz-company');
    var doneStep = wizCard.querySelector('.wiz-done');
    var form     = wizCard.querySelector('.wiz-contact-form');
    var steps    = Array.prototype.slice.call(wizCard.querySelectorAll('.wiz-step'));

    var TOTAL = groups.length;       // number of question steps
    var FINAL = TOTAL + 1;           // the contact step
    var waNumber = (wizCard.dataset.whatsapp || '').replace(/[^0-9]/g, '');
    var mode = wizCard.dataset.submit || 'whatsapp'; // 'whatsapp' | 'message'

    // Build label + order from the markup (data-key / data-label on each group)
    var order = groups.map(function (g) { return g.dataset.key; });
    var labels = {};
    groups.forEach(function (g) { labels[g.dataset.key] = g.dataset.label || g.dataset.key; });

    var answers = {};
    var current = 1;

    function decode(s) {
      var ta = document.createElement('textarea');
      ta.innerHTML = s || '';
      return ta.value;
    }
    function show(n, opts) {
      current = n;
      steps.forEach(function (s) { s.classList.toggle('is-active', Number(s.dataset.step) === n); });
      if (n <= TOTAL) {
        stepLab.textContent = 'Question ' + n + ' of ' + TOTAL;
        barFill.style.width = (n / TOTAL * 100) + '%';
        nextBtn.style.display = 'inline-flex';
        var stepEl = wizCard.querySelector('.wiz-step[data-step="' + n + '"]');
        var key = stepEl.querySelector('.wiz-options').dataset.key;
        nextBtn.disabled = !answers[key];
      } else {
        stepLab.textContent = 'Almost done — your details';
        barFill.style.width = '100%';
        nextBtn.style.display = 'none';
        populateSummary();
        validateContact();
      }
      backBtn.disabled = (n === 1);
      if (opts && opts.scroll) wizCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function populateSummary() {
      if (!sumList) return;
      sumList.innerHTML = order.map(function (k) {
        return '<li><span>' + labels[k] + '</span><span>' + (answers[k] || '—') + '</span></li>';
      }).join('');
    }
    function validateContact() {
      if (!sendBtn) return;
      var ok = nameIn.value.trim().length > 0 && waIn.value.trim().length >= 8;
      sendBtn.disabled = !ok;
    }

    groups.forEach(function (group) {
      var key = group.dataset.key;
      group.querySelectorAll('.wiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.wiz-option').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          answers[key] = decode(btn.dataset.value);
          nextBtn.disabled = false;
        });
      });
    });

    nextBtn.addEventListener('click', function () { if (current < FINAL) show(current + 1, { scroll: true }); });
    backBtn.addEventListener('click', function () { if (current > 1) show(current - 1, { scroll: true }); });
    [nameIn, waIn].forEach(function (inp) { if (inp) inp.addEventListener('input', validateContact); });

    if (sendBtn) {
      sendBtn.addEventListener('click', function () {
        var name = nameIn.value.trim();
        var company = compIn ? compIn.value.trim() : '';
        var whatsapp = waIn.value.trim();
        var lines = ['Hi 👋', '', "Here's my gift brief:"];
        order.forEach(function (k) { lines.push('• ' + labels[k] + ': ' + (answers[k] || '—')); });
        lines.push('', 'My details:', '• Name: ' + name, '• Company: ' + (company || '—'), '• WhatsApp: ' + whatsapp);

        if (mode === 'whatsapp' && waNumber) {
          var url = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(lines.join('\n'));
          window.open(url, '_blank', 'noopener');
        }
        // Show the on-screen thank-you either way
        if (doneStep) {
          if (form) form.style.display = 'none';
          doneStep.style.display = 'block';
          doneStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    show(1);
  });
});

/* =================================================================
   QUEM v2 — Header nav, sidebar, search overlay, events tabs
   ================================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* --- Topbar marquee --- */
  document.querySelectorAll('.q-topbar-track').forEach(function (t) {
    if (t.dataset.looped === '1') return;
    t.innerHTML += t.innerHTML;
    t.dataset.looped = '1';
  });

  /* --- Chrome height (topbar + sticky header) so a full-viewport hero
     fills exactly what's left below them, with no scroll needed --- */
  (function () {
    var topbar = document.querySelector('.q-topbar');
    var header = document.querySelector('.q-header');
    function measure() {
      var h = 0;
      if (topbar && getComputedStyle(topbar).display !== 'none') h += topbar.offsetHeight;
      if (header) h += header.offsetHeight;
      document.documentElement.style.setProperty('--qz-chrome-h', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  })();

  /* --- Mega menu --- */
  (function () {
    var zone = document.getElementById('qNavzone');
    if (!zone) return;
    var items = Array.from(zone.querySelectorAll('.q-nav-item[data-mega]'));
    var timer = null;
    function open(key) {
      clearTimeout(timer);
      items.forEach(function (it) { it.classList.toggle('is-open', it.dataset.mega === key); });
      zone.querySelectorAll('.q-mega').forEach(function (m) { m.classList.toggle('is-open', m.id === 'q-mega-' + key); });
    }
    function close() {
      items.forEach(function (it) { it.classList.remove('is-open'); });
      zone.querySelectorAll('.q-mega').forEach(function (m) { m.classList.remove('is-open'); });
    }
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () { open(it.dataset.mega); });
      var btn = it.querySelector('.q-nav-link');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        it.classList.contains('is-open') ? close() : open(it.dataset.mega);
      });
    });
    zone.addEventListener('mouseleave', function () { timer = setTimeout(close, 140); });
    zone.addEventListener('mouseenter', function () { clearTimeout(timer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* --- Compact PDP header: back + share --- */
  (function () {
    var backBtn = document.getElementById('qBackBtn');
    var shareBtn = document.getElementById('qShareBtn');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      });
    }
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var shareData = { title: document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(shareData.url).then(function () {
            shareBtn.setAttribute('aria-label', 'Link copied');
            setTimeout(function () { shareBtn.setAttribute('aria-label', 'Share this product'); }, 2000);
          });
        }
      });
    }
  })();

  /* --- Mobile sidebar --- */
  (function () {
    var sidebar  = document.getElementById('qMobSidebar');
    var backdrop = document.getElementById('qMobBackdrop');
    var openBtn  = document.getElementById('qHamburgerBtn');
    var closeBtn = document.getElementById('qMobClose');
    if (!sidebar || !openBtn) return;
    function openSidebar()  { sidebar.classList.add('is-open'); backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeSidebar() { sidebar.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    backdrop.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSidebar(); });
    sidebar.querySelectorAll('[data-mob-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.q-mob-item');
        var wasOpen = item.classList.contains('is-open');
        sidebar.querySelectorAll('.q-mob-item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  })();

  /* --- Search overlay: open/close, recent + trending chips, live product suggestions --- */
  (function () {
    var overlay  = document.getElementById('qSearchOverlay');
    var backdrop = document.getElementById('qSearchBackdrop');
    var openBtn  = document.getElementById('qSearchBtn');
    var closeBtn = document.getElementById('qSearchClose');
    var clearBtn = document.getElementById('qSearchClear');
    var input    = document.getElementById('qSearchInput');
    var form     = document.getElementById('qSearchForm');
    var resultsEl = document.getElementById('qSearchResults');
    var recentWrap = document.getElementById('qSearchRecent');
    var recentRow  = document.getElementById('qSearchRecentRow');
    var trendingRow = document.querySelector('#qSearchTrending .q-search-chips-row');
    if (!overlay || !openBtn) return;

    var RECENT_KEY = 'quem_recent_searches';
    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
    }
    function saveRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
      renderRecent();
    }
    function renderRecent() {
      if (!recentWrap || !recentRow) return;
      var list = getRecent();
      recentRow.innerHTML = '';
      if (!list.length) { recentWrap.hidden = true; return; }
      recentWrap.hidden = false;
      list.forEach(function (term) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'q-search-chip';
        chip.textContent = term;
        chip.addEventListener('click', function () { input.value = term; toggleClearBtn(); runSearch(term); input.focus(); });
        recentRow.appendChild(chip);
      });
    }
    if (trendingRow) {
      trendingRow.querySelectorAll('.q-search-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          input.value = chip.textContent;
          toggleClearBtn();
          runSearch(chip.textContent);
          input.focus();
        });
      });
    }

    function renderResult(product) {
      var a = document.createElement('a');
      a.className = 'q-search-result';
      a.href = product.url;
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var meta = document.createElement('span');
      var name = document.createElement('span');
      name.className = 'name';
      name.textContent = product.title;
      var price = document.createElement('span');
      price.className = 'price';
      price.textContent = product.price;
      meta.appendChild(name);
      meta.appendChild(price);
      a.appendChild(meta);
      return a;
    }

    var debounceTimer, activeController;
    function runSearch(query) {
      query = (query || '').trim();
      if (!resultsEl) return;
      if (activeController) activeController.abort();
      if (query.length < 2) { resultsEl.innerHTML = ''; return; }
      activeController = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: activeController && activeController.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          resultsEl.innerHTML = '';
          if (!products.length) {
            var empty = document.createElement('div');
            empty.className = 'q-search-empty';
            empty.textContent = 'No products found.';
            resultsEl.appendChild(empty);
            return;
          }
          products.forEach(function (p) { resultsEl.appendChild(renderResult(p)); });
        })
        .catch(function () {});
    }

    function toggleClearBtn() {
      if (clearBtn) clearBtn.hidden = !input || input.value.length === 0;
    }
    if (input) {
      input.addEventListener('input', function () {
        toggleClearBtn();
        clearTimeout(debounceTimer);
        var q = input.value;
        debounceTimer = setTimeout(function () { runSearch(q); }, 220);
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        toggleClearBtn();
        runSearch('');
        input.focus();
      });
    }
    if (form) form.addEventListener('submit', function () { saveRecent(input.value); });

    function openSearch()  {
      overlay.classList.add('is-open'); backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      renderRecent();
      toggleClearBtn();
      setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function closeSearch() { overlay.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  })();

  /* --- Events tabs --- */
  (function () {
    var tabs = document.querySelectorAll('.events-tab');
    var sec  = document.querySelector('.events-sec');
    if (!sec || !tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        sec.querySelectorAll('.events-panel').forEach(function (p) { p.style.display = 'none'; });
        var panel = document.getElementById('q-tab-' + tab.dataset.tab);
        if (panel) panel.style.display = 'block';
      });
    });
  })();

  /* --- Cart badge (live count) --- */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var badge = document.getElementById('qCartBadge');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  }).catch(function () {});

});

/* =================================================================
   QUEM v2 — homepage additions: hero slider, FAQ accordion,
   "Shop by Use" tabs, looping product carousel
   ================================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Hero slider (autoplay + arrows + dots) — true infinite loop,
     same clone + snap-back technique as the looping product carousel below,
     so wrapping from last slide back to first never has to "jump" ---------- */
  document.querySelectorAll('.hero-slider').forEach(function (root) {
    var track = root.querySelector('.hs-track');
    var originals = Array.prototype.slice.call(root.querySelectorAll('.hs-slide'));
    var n = originals.length;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hs-dot'));
    if (!track || n < 2) return;

    var cloneFirst = originals[0].cloneNode(true);
    var cloneLast = originals[n - 1].cloneNode(true);
    cloneFirst.setAttribute('aria-hidden', 'true');
    cloneLast.setAttribute('aria-hidden', 'true');
    track.insertBefore(cloneLast, originals[0]);
    track.appendChild(cloneFirst);

    var index = 1; // track position: [cloneLast, ...originals, cloneFirst]
    var animating = false;

    function apply(withTransition) {
      track.style.transition = withTransition ? 'transform .6s cubic-bezier(.4,0,.2,1)' : 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
    }
    apply(false);

    function updateDots() {
      var real = (index - 1 + n) % n;
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === real); });
    }
    updateDots();

    track.addEventListener('transitionend', function () {
      animating = false;
      if (index === 0) { index = n; apply(false); }
      else if (index === n + 1) { index = 1; apply(false); }
    });

    function go(dir) {
      if (animating) return;
      animating = true;
      index += dir;
      apply(true);
      updateDots();
    }
    function goTo(realIdx) {
      if (animating || realIdx === (index - 1 + n) % n) return;
      animating = true;
      index = realIdx + 1;
      apply(true);
      updateDots();
    }

    var timer;
    function restart() { clearInterval(timer); timer = setInterval(function () { go(1); }, 5500); }
    var prev = root.querySelector('.hs-arrow--prev');
    var next = root.querySelector('.hs-arrow--next');
    if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
    if (next) next.addEventListener('click', function () { go(1); restart(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.dataset.goto); restart(); }); });
    restart();
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      var list = item.closest('.faq-list') || item.parentElement;
      list.querySelectorAll('.faq-item.is-open').forEach(function (it) {
        it.classList.remove('is-open');
        it.querySelector('.faq-a').style.maxHeight = '0px';
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---------- "Shop by Use" tabs (scoped per section instance) ---------- */
  document.querySelectorAll('.use-sec').forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('.use-tab'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        sec.querySelectorAll('.use-panel').forEach(function (p) { p.classList.remove('is-active'); });
        var panel = sec.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) {
          panel.classList.add('is-active');
          var car = panel.querySelector('.pcarousel');
          if (car && car._reflow) car._reflow();
        }
      });
    });
  });

  /* ---------- Horizontal-scroll progress bars ---------- */
  document.querySelectorAll('[data-hscroll-bar-for]').forEach(function (bar) {
    var scroller = document.getElementById(bar.dataset.hscrollBarFor);
    var thumb = bar.querySelector('.hscroll-bar-thumb');
    if (!scroller || !thumb) return;
    function update() {
      var track = scroller.scrollWidth;
      var visible = scroller.clientWidth;
      if (track <= visible) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      var widthPct = Math.max((visible / track) * 100, 8);
      var maxScroll = track - visible;
      var fraction = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      thumb.style.width = widthPct + '%';
      thumb.style.left = (fraction * (100 - widthPct)) + '%';
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Looping product carousels (arrows + drag) ---------- */
  document.querySelectorAll('.pcarousel').forEach(function (root) {
    var track = root.querySelector('.pcarousel-track');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (!n) return;
    var cloneA = originals.map(function (c) { return c.cloneNode(true); });
    var cloneB = originals.map(function (c) { return c.cloneNode(true); });
    track.prepend.apply(track, cloneA);
    track.append.apply(track, cloneB);
    var index = n, animating = false;
    function step() {
      var card = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '18') || 18;
      return card.getBoundingClientRect().width + gap;
    }
    function apply(withTransition) {
      track.style.transition = withTransition ? 'transform .45s cubic-bezier(.4,0,.2,1)' : 'none';
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
    }
    apply(false);
    function settle() {
      if (index >= 2 * n) { index -= n; apply(false); }
      else if (index < n) { if (index <= 0) { index += n; apply(false); } }
    }
    track.addEventListener('transitionend', function () { animating = false; settle(); });
    function go(dir) { if (animating) return; animating = true; index += dir; apply(true); }
    var prevBtn = root.querySelector('.pcarousel-arrow--prev');
    var nextBtn = root.querySelector('.pcarousel-arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    /* drag / swipe */
    var dragging = false, startX = 0, baseX = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; startX = e.clientX;
      baseX = -index * step();
      track.style.transition = 'none';
      track.classList.add('is-dragging');
      track.setPointerCapture && track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.style.transform = 'translateX(' + (baseX + dx) + 'px)';
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var dx = (e.clientX || 0) - startX;
      if (moved && Math.abs(dx) > 60) { go(dx < 0 ? 1 : -1); }
      else { animating = false; apply(true); }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { apply(false); }, 150); });
    root._reflow = function () { apply(false); };
  });

  /* ---------- Standard product page: gallery (infinite loop), variant swatches, quantity stepper ---------- */
  (function () {
    /* gallery: same clone + snap-back infinite-loop technique as the hero slider */
    var galleryGoTo = null;
    (function () {
      var gallery = document.getElementById('QuemGallery');
      var track = document.getElementById('QuemGalleryTrack');
      if (!gallery || !track) return;
      var originals = Array.prototype.slice.call(track.querySelectorAll('.q-pdp-slide'));
      var n = originals.length;
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('.hs-dot'));
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.q-pdp-thumb'));
      if (n < 2) return;

      var cloneFirst = originals[0].cloneNode(true);
      var cloneLast = originals[n - 1].cloneNode(true);
      cloneFirst.setAttribute('aria-hidden', 'true');
      cloneLast.setAttribute('aria-hidden', 'true');
      track.insertBefore(cloneLast, originals[0]);
      track.appendChild(cloneFirst);

      var index = 1;
      var animating = false;

      function apply(withTransition) {
        track.style.transition = withTransition ? 'transform .45s cubic-bezier(.4,0,.2,1)' : 'none';
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
      }
      apply(false);

      function updateIndicators() {
        var real = (index - 1 + n) % n;
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === real); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === real); });
      }
      updateIndicators();

      track.addEventListener('transitionend', function () {
        animating = false;
        if (index === 0) { index = n; apply(false); }
        else if (index === n + 1) { index = 1; apply(false); }
      });

      function go(dir) {
        if (animating) return;
        animating = true;
        index += dir;
        apply(true);
        updateIndicators();
      }
      function goTo(realIdx) {
        if (animating || realIdx === (index - 1 + n) % n) return;
        animating = true;
        index = realIdx + 1;
        apply(true);
        updateIndicators();
      }
      galleryGoTo = goTo;

      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.dataset.goto); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.goto); }); });

      /* hand-swipe / drag, like an Instagram carousel */
      var dragging = false, dragStartX = 0, dragBaseIndex = 0, dragPct = 0, wrapWidth = 0;
      gallery.addEventListener('pointerdown', function (e) {
        if (animating) return;
        dragging = true;
        dragStartX = e.clientX;
        dragBaseIndex = index;
        wrapWidth = gallery.getBoundingClientRect().width || 1;
        track.style.transition = 'none';
        gallery.setPointerCapture && gallery.setPointerCapture(e.pointerId);
      });
      gallery.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        dragPct = (dx / wrapWidth) * 100;
        track.style.transform = 'translateX(' + (-dragBaseIndex * 100 + dragPct) + '%)';
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(dragPct) > 15) {
          animating = true;
          index = dragBaseIndex + (dragPct < 0 ? 1 : -1);
          apply(true);
          updateIndicators();
        } else {
          apply(true);
        }
        dragPct = 0;
      }
      gallery.addEventListener('pointerup', endDrag);
      gallery.addEventListener('pointercancel', endDrag);
      gallery.addEventListener('dragstart', function (e) { e.preventDefault(); });
    })();

    var form = document.getElementById('QuemProductForm');
    if (form) {
      var dataEl = document.getElementById('QuemVariantData');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var groups = Array.prototype.slice.call(form.querySelectorAll('.q-option-group'));
      var variantIdInput = document.getElementById('QuemVariantId');
      var priceEl = document.getElementById('QuemPrice');
      var compareEl = document.getElementById('QuemComparePrice');
      var addBtn = document.getElementById('QuemAddToCart');
      var addLabel = document.getElementById('QuemAddLabel');
      var stickyPriceEl = document.getElementById('QuemStickyPrice');
      var stickyAddBtn = document.getElementById('QuemStickyAddBtn');
      var stickyAddLabel = document.getElementById('QuemStickyAddLabel');

      function selectedValues() {
        return groups.map(function (g) {
          var active = g.querySelector('.q-swatch.is-selected');
          return active ? active.dataset.value : null;
        });
      }
      function findVariant() {
        var values = selectedValues();
        return variants.filter(function (v) {
          return values.every(function (val, idx) { return v['option' + (idx + 1)] === val; });
        })[0];
      }
      function updateUI() {
        var variant = findVariant();
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          if (variant.compare_at_price) { compareEl.textContent = variant.compare_at_price; compareEl.style.display = ''; }
          else { compareEl.style.display = 'none'; }
        }
        if (addBtn && addLabel) {
          addBtn.disabled = !variant.available;
          addLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
        if (galleryGoTo && variant.image_index >= 0) galleryGoTo(variant.image_index);
        if (stickyPriceEl) stickyPriceEl.textContent = variant.price;
        if (stickyAddBtn && stickyAddLabel) {
          stickyAddBtn.disabled = !variant.available;
          stickyAddLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('.q-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('.q-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            updateUI();
          });
        });
      });

      /* ---------- AJAX add-to-cart: toast + optional "complete your purchase" upsell ---------- */
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
      var TOAST_MS = 3000;
      var toastEl, toastTimer, toastRAF;

      function refreshCartBadge() {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var badge = document.getElementById('qCartBadge');
          if (badge) badge.textContent = cart.item_count;
        }).catch(function () {});
      }

      function ajaxAdd(variantId, quantity, onDone) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
        }).then(function (r) { return r.json(); }).then(function (data) {
          refreshCartBadge();
          if (onDone) onDone(null, data);
        }).catch(function (err) {
          if (onDone) onDone(err);
        });
      }

      function buildToast() {
        if (toastEl) return toastEl;
        toastEl = document.createElement('div');
        toastEl.className = 'q-toast';
        toastEl.innerHTML =
          '<span class="q-toast-msg">Product added to cart</span>' +
          '<a class="q-toast-cta" href="' + cartUrl + '">Visit Cart</a>' +
          '<svg class="q-toast-ring" width="26" height="26" viewBox="0 0 28 28" aria-hidden="true">' +
            '<circle class="q-toast-ring-bg" cx="14" cy="14" r="12"></circle>' +
            '<circle class="q-toast-ring-fg" cx="14" cy="14" r="12"></circle>' +
          '</svg>';
        document.body.appendChild(toastEl);
        document.addEventListener('click', function (e) {
          if (toastEl.classList.contains('is-visible') && !toastEl.contains(e.target)) hideToast();
        });
        return toastEl;
      }
      function hideToast() {
        if (!toastEl) return;
        clearTimeout(toastTimer);
        cancelAnimationFrame(toastRAF);
        toastEl.classList.remove('is-visible');
      }
      function showToast() {
        var el = buildToast();
        clearTimeout(toastTimer);
        cancelAnimationFrame(toastRAF);
        el.classList.add('is-visible');
        var ring = el.querySelector('.q-toast-ring-fg');
        var circumference = 2 * Math.PI * 12;
        ring.style.strokeDasharray = circumference;
        ring.style.strokeDashoffset = 0;
        var start = performance.now();
        function tick(now) {
          var progress = Math.min((now - start) / TOAST_MS, 1);
          ring.style.strokeDashoffset = circumference * progress;
          if (progress < 1) toastRAF = requestAnimationFrame(tick);
        }
        toastRAF = requestAnimationFrame(tick);
        toastTimer = setTimeout(hideToast, TOAST_MS);
      }

      function showUpsellModal(upsell) {
        var backdrop = document.createElement('div');
        backdrop.className = 'q-upsell-backdrop';
        backdrop.innerHTML =
          '<div class="q-upsell-modal">' +
            '<div class="q-upsell-head"><h3>Complete your purchase</h3><button type="button" class="q-upsell-close" aria-label="Close">&times;</button></div>' +
            '<div class="q-upsell-row">' +
              '<a class="q-upsell-thumb" href="' + upsell.url + '">' + (upsell.image ? '<img src="' + upsell.image + '" alt="' + upsell.title.replace(/"/g, '&quot;') + '">' : '') + '</a>' +
              '<div class="q-upsell-info">' +
                '<a class="q-upsell-title" href="' + upsell.url + '">' + upsell.title + '</a>' +
                '<div class="q-upsell-price"><span class="price">' + upsell.price + '</span>' + (upsell.compare_at_price ? '<span class="price-compare">' + upsell.compare_at_price + '</span>' : '') + '</div>' +
                '<button type="button" class="q-upsell-add">+ Add</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="q-btn q-btn--dark q-upsell-cart-btn">Go to Cart →</button>' +
          '</div>';
        document.body.appendChild(backdrop);
        requestAnimationFrame(function () { backdrop.classList.add('is-visible'); });

        function close() {
          backdrop.classList.remove('is-visible');
          setTimeout(function () { backdrop.remove(); }, 300);
        }
        backdrop.querySelector('.q-upsell-close').addEventListener('click', close);
        backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
        backdrop.querySelector('.q-upsell-cart-btn').addEventListener('click', function () {
          window.location.href = cartUrl;
        });
        var upsellAddBtn = backdrop.querySelector('.q-upsell-add');
        upsellAddBtn.addEventListener('click', function () {
          upsellAddBtn.disabled = true;
          ajaxAdd(upsell.variant_id, 1, function (err) {
            upsellAddBtn.textContent = err ? '+ Add' : 'Added ✓';
            upsellAddBtn.disabled = !err;
            if (!err) showToast();
          });
        });
      }

      function maybeShowUpsell() {
        var dataEl = document.getElementById('QuemUpsellData');
        if (!dataEl) return;
        try {
          showUpsellModal(JSON.parse(dataEl.textContent));
        } catch (e) {}
      }

      function interceptAdd(btn) {
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          if (btn.disabled) return;
          e.preventDefault();
          var qtyInput = document.getElementById('QuemQty');
          var variantId = variantIdInput ? variantIdInput.value : form.querySelector('[name="id"]').value;
          var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          btn.disabled = true;
          ajaxAdd(variantId, qty, function (err) {
            btn.disabled = false;
            if (err) return;
            showToast();
            maybeShowUpsell();
          });
        });
      }
      interceptAdd(addBtn);
      interceptAdd(stickyAddBtn);
    }

    /* Sticky "Add to Cart" bar: visible once the inline buy row scrolls out
       of view above, hidden again once the accordions (product details,
       specifications, delivery & returns) have been scrolled past */
    (function () {
      var bar = document.getElementById('QuemStickyBuy');
      var buyRow = document.getElementById('QuemBuyRow');
      var accordion = document.getElementById('QuemAccordion');
      if (!bar || !buyRow || !accordion) return;
      var ticking = false;
      function update() {
        ticking = false;
        var pastBuyRow = buyRow.getBoundingClientRect().bottom < 0;
        var pastAccordion = accordion.getBoundingClientRect().bottom < 0;
        var visible = pastBuyRow && !pastAccordion;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-sticky-buy', visible);
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

    document.querySelectorAll('.q-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        var dir = parseInt(btn.getAttribute('data-dir'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
        input.value = val;
      });
    });

    /* pincode delivery check (informational only — no live serviceability API) */
    var pinBtn = document.getElementById('QuemPincodeCheck');
    if (pinBtn) {
      pinBtn.addEventListener('click', function () {
        var input = document.getElementById('QuemPincode');
        var msg = document.getElementById('QuemPincodeMsg');
        if (!input || !msg) return;
        var valid = /^\d{6}$/.test(input.value.trim());
        if (!valid) {
          msg.textContent = 'Enter a valid 6-digit pincode.';
          msg.classList.add('is-error');
        } else {
          msg.textContent = 'We deliver pan-India — typically 3–7 working days.';
          msg.classList.remove('is-error');
        }
      });
    }
  })();

  /* ---------- Wishlist heart (per-browser, no account needed) ---------- */
  (function () {
    var KEY = 'quem_wishlist';
    function getList() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function setList(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function paint(btn, liked) {
      btn.classList.toggle('is-liked', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    }
    function updateBadge() {
      var badge = document.getElementById('qWishBadge');
      if (!badge) return;
      var count = getList().length;
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    window.QuemWishlist = { getList: getList, updateBadge: updateBadge };
    document.querySelectorAll('.prod-wish').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      if (!handle) return;
      paint(btn, getList().indexOf(handle) !== -1);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getList();
        var idx = list.indexOf(handle);
        var adding = idx === -1;
        if (adding) list.push(handle); else list.splice(idx, 1);
        setList(list);
        paint(btn, adding);
        updateBadge();
        if (adding) window.location.href = '/pages/wishlist';
      });
    });
    updateBadge();
  })();

});
